module.exports = __webpack_public_path__ + "static/img/15.5a8a0408.png";